import React from "react";
import MobileViewIcon from "../../../../icons/mobile-view.icon";
import cn from "../../../../../Utils/class-names.utils";
import styles from "./view-selector.component.module.scss";
import DesktopViewIcon from "../../../../icons/desktop-view.icon";

export enum ViewOption {
  MOBILE = "mobile",
  DESKTOP = "desktop",
}

interface ViewSelectorProps {
  activeView: ViewOption;
  setActiveView: (view: ViewOption) => void;
}

const ViewSelector = ({ activeView, setActiveView }: ViewSelectorProps) => {

  const viewOptions = [
    {
      id: ViewOption.MOBILE,
      label: "Mobile View",
      icon: MobileViewIcon,
    },
    {
      id: ViewOption.DESKTOP,
      label: "Desktop View",
      icon: DesktopViewIcon,
    },
  ];

  return (
    <div
      className={styles.container}
      role="group"
      aria-label="View toggle"
    >
      {viewOptions.map((option) => {
        const IconComponent = option.icon;
        const isActive = activeView === option.id;

        return (
          <button
            key={option.id}
            onClick={() => setActiveView(option.id)}
            className={cn(styles.button, 'my-button', {
              [styles.active]: isActive,
            })}
            aria-pressed={isActive}
            aria-label={option.label}
            type="button"
          >
            <div className={styles.iconContainer}>
              <IconComponent color={isActive ? '#0C0D11' : '#616778'} className={cn(styles.icon)} />
            </div>

            <div className={styles.labelContainer}>
              <div
                className={cn(styles.label, {
                  [styles.active]: isActive,
                  [styles.inactive]: !isActive,
                })}
              >
                {option.label}
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default ViewSelector;
